import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SearchIcon = styled(FontAwesomeIcon)`
	font-size: 1.5em;
	color: var(--primary);
`
